import { render, staticRenderFns } from "./CallButton.vue?vue&type=template&id=4a35a9d0&"
import script from "./CallButton.vue?vue&type=script&lang=ts&"
export * from "./CallButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports